import React, { useState } from 'react';
import {
    Card,
    CardTitle,
    CardText,
    Input,
} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
interface CustomCardProps {
    id: string;
    title: string;
    description: string;
    ActionEffectivenessReason: string;
    roundName: string;
    onCardDataChange: (data: {
        roundName: string,
        cardId: string,
        Rating: number,
        ActionEffectivenessReason: string
    }) => void
}
const CustomCard: React.FC<CustomCardProps> = ({
    id,
    title,
    description,
    ActionEffectivenessReason,
    roundName,
    onCardDataChange
}) => {
   
    const [Rating, setRating] = useState<number>(0);
    const handleRating = (value: number, id: any) => {
        setRating(value);
        onCardDataChange({
            roundName,
            cardId: id,
            Rating: value,
            ActionEffectivenessReason
        })
    };
    const handleInputChange = (value: string) => {
        const trimmed = value.slice(0, 1000);
        onCardDataChange({
            roundName,
            cardId: id,
            Rating,
            ActionEffectivenessReason: trimmed,
        });
    };

    return (
        <Card className='default-card p-3'>
            <CardTitle className='card-title'>{title}</CardTitle>
            <CardText className='card-description'>{description}</CardText>
            {/* Rating section */}
            <div style={{ marginBottom: '10px' }}>
                <strong style={{ fontSize: '13px' }}>Please rate the action:</strong>
                <div style={{ fontSize: '32px', color: '#007bff', cursor: 'pointer' }}>
                    {[1, 2, 3, 4, 5].map((star) => (
                        <button
                            key={star}
                            type="button"
                            onClick={() => handleRating(star, id)}
                            className='NewCardButton'
                            style={{ color: star <= Rating ? '#004e8c' : '#ccc' }}
                        >
                            ★
                        </button>
                    ))}
                </div>
            </div>
            <div>
                <strong className='implementation-plan' style={{ fontSize: '13px' }}>Why did the action work well / not so well</strong>
                <Input
                    type="textarea"
                    rows={2}
                    placeholder="..."
                    value={ActionEffectivenessReason}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => {
                        
                        handleInputChange(e.target.value);
                    }}
                    style={{ fontSize: '14px', marginTop: '5px' }}
                />
            </div>
            {ActionEffectivenessReason?.length === 1000 && (
                <div className='input-text'>Maximum 1000 characters allowed</div>
            )}
        </Card>
    );
};

export default CustomCard;

